'use strict';

function pluralize(n, singular, plural) {
  return (n === 1) ? singular : plural;
}

module.exports = pluralize;


/** WEBPACK FOOTER **
 ** ./utils/pluralize.js
 **/